import { render, staticRenderFns } from "./CInfoPageTemplate.vue?vue&type=template&id=aae820fc&scoped=true"
import script from "./CInfoPageTemplate.vue?vue&type=script&lang=js"
export * from "./CInfoPageTemplate.vue?vue&type=script&lang=js"
import style0 from "./CInfoPageTemplate.vue?vue&type=style&index=0&id=aae820fc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aae820fc",
  null
  
)

export default component.exports